/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useState } from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { twMerge } from 'tailwind-merge';
import { useNavigate } from 'react-router-dom';
import {
  generateSlugifyUrl, getPaginationItems, itemsPerPage, maxLength,
} from '../../utils';
import { OpenJob } from '../../types';

interface GridViewCardsProps {
  jobs: OpenJob[];
  search: string;
}

function GridViewCards(props: GridViewCardsProps) {
  const { jobs, search } = props;
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(jobs.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = jobs.slice(indexOfFirstItem, indexOfLastItem);

  const pageNums = getPaginationItems(currentPage, totalPages, maxLength);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  return (
    <>
      <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-5">
        {currentItems.map((job: OpenJob) => (
          <div
            onClick={() => {
              navigate(`/${job.organizationId}${generateSlugifyUrl(job)}`);
            }}
            role="button"
            key={job.jobId}
            className="block relative bg-[#F4F4F4] rounded-xl cursor-pointer overflow-hidden"
          >
            <div className="left-0 z-10 absolute bg-primary rounded-tl-full rounded-bl-full w-4 h-full" />
            <div className="right-2 bottom-2 absolute flex justify-center items-center bg-[#D9D9D9]/20 rounded-md w-10 h-10">
              <HiArrowNarrowRight className="w-4 h-4 text-gray-300" />
            </div>
            <div className="relative z-20 p-10">
              <p className="relative z-20 font-bold text-black text-xl">
                {job.jobTitle}
              </p>
              <p className="mt-8 font-light text-base uppercase">
                {job.location}
              </p>
              {/* <p className="mt-2 font-bold text-base text-primary">
                {moment(job.date).format("DD/MM/YYYY")}
              </p> */}
            </div>
          </div>
        ))}
      </div>

      {/* pagination */}
      <div className="flex flex-wrap justify-between gap-y-4 mt-5">
        <div>
          {(currentPage * itemsPerPage) > jobs.length ? jobs.length : (currentPage * itemsPerPage)}
          {' '}
          of
          {jobs.length}
        </div>

        {jobs.length > itemsPerPage ? (
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              type="button"
              onClick={() => setCurrentPage((prevPage) => prevPage - 1)}
              disabled={currentPage === 1}
              className="w-6 h-6 cursor-pointer disabled:hover:cursor-not-allowed"
            >
              <GrFormPrevious
                className={currentPage === 1 ? '[&>*]:stroke-[#B0B0B0]' : ''}
              />
            </button>
            {pageNums.map((pageNumber) => (
              <button
                type="button"
                key={pageNumber}
                disabled={Number.isNaN(pageNumber)}
                onClick={() => setCurrentPage(pageNumber)}
                className={twMerge(
                  'pb-6 w-6 h-6',
                  pageNumber === currentPage ? 'font-bold border-b border-black' : 'font-normal',
                )}
              >
                {Number.isNaN(pageNumber) ? '...' : pageNumber}
              </button>
            ))}
            <button
              type="button"
              onClick={() => setCurrentPage((prevPage) => prevPage + 1)}
              disabled={currentPage === totalPages}
              className="w-6 h-6 cursor-pointer disabled:hover:cursor-not-allowed"
            >
              <GrFormNext
                className={currentPage === totalPages ? '[&>*]:stroke-[#B0B0B0]' : ''}
              />
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default GridViewCards;
